
import { apiInitialState } from '@percept/redux'

import { getPath, any } from '@percept/utils'


export const getJobPayload = (state, job_id) => state.jobs.payloadsById[job_id] || apiInitialState

// export const getJobEntity = (state, job_id) => 
